module.exports = __webpack_public_path__ + "img/sticker_app_2.e17c7098.svg";